const content = {
    hulu_data_upload: {
        en: {
            data_type_description: 'Hulu Data Upload',
            summary_no_video_html: '<p>This is the second part of the Hulu data task. Please upload your Hulu data file by following the instructions below:</p>',
            steps: [
                {
                    step_type: 'numbered_step',
                    number: '1',
                    description_html: '<p>You should have been notified by email that a comment has been added to your request - this will have been an email sent to you within a few hours after you requested it.</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '2',
                    description_html: '<p>Click on <b>View Request</b> in email and follow steps to access your request using an access code.</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '3',
                    description_html: '<p>Click on <b>View Details</b> for the most recent request. </p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '4',
                    description_html: `<p>Click on <b>HERE</b> to download a copy of your right to know report.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '5',
                    description_html: `<p>Download the file to your mobile phone.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '6',
                    description_html: `<p>To upload your data, simply tap on <b>Choose file</b> below — find the file that you just saved and then upload it. 
                                          As some files are large, we suggest that you are connecting to wifi to make the upload process as quick as possible.</p>`
                },
                {
                    step_type: 'emoji_step',
                    emoji: '💡',
                    description_html: `<p>PLEASE NOTE WE USE A SECURE UPLOAD SERVICE TO PROTECT YOUR DATA AND YOUR PRIVACY.</p>`
                },
            ]
        }
    }
};

export const huluDataTypes = {
    hulu_data_upload: {
        data_type: 'hulu_data_upload',
        data_type_description: 'Hulu Data Upload',
        logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/hulu.96x96.png',
        capture_type: 'file',
        use_in_app_screen_recorder: false,
        require_consent: true,
        generic: {
            ...content.hulu_data_upload,
        }
    },
};